import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './FinanceUploadFolder.css';

const FINANCE_ROOT = process.env.REACT_APP_FINANCE_START_PATH || '/finance';

function FinanceUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={FINANCE_ROOT}
      sessionPrefix="finance_folder"
    />
  );
}

FinanceUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default FinanceUploadFolder;
